<template>
  <div class="ban">
    <div class="demo-input-suffix">
      <el-input
        placeholder="ASN number"
        v-model="Queryproductval"
        @blur="Queryproduct"
        class="input"
        suffix-icon="el-icon-search"
      ></el-input>
    </div>
    <div class="demo-input-suffix">
      <el-tabs v-model="activeName" @tab-click="handleClick">
        <el-tab-pane name="Unreceived">
          <span slot="label">
            Unreceived
            <el-badge :value="countUnReceiveing" size="mini" class="item"></el-badge>
          </span>
          <el-table
            ref="multipleTable"
            :data="tableData"
            border
            style="width: 100%"
            v-loading="loading"
          >
            <!-- <el-table-column type="selection" width="60" fixed="left"></el-table-column> -->
            <el-table-column prop="AsnCreateTime" label="Creation time" width="100">
              <!-- <template slot-scope="scope">
                <img :src="scope.row.eNumber" min-width="70" height="70">
              </template>-->
            </el-table-column>
            <el-table-column prop="AsnCode" label="ASN number" show-overflow-tooltip></el-table-column>
            <el-table-column prop="refCode" label="Reference No"></el-table-column>
            <el-table-column prop="AsnDetail" label="SKU number">
              <template slot-scope="scope" v-if="scope.row.AsnDetail">
                <span v-if="scope.row.AsnDetail.length>0">{{scope.row.AsnDetail.length}}</span>
                <span v-else>1</span>
              </template>
            </el-table-column>
            <el-table-column prop="warehouseId" label="Warehouse" width="180">
              <template slot-scope="scope" v-if="scope.row.warehouseId=='4'">SHENZHEN02</template>
              <template slot-scope="scope" v-else-if="scope.row.warehouseId=='5'">香港仓</template>
            </el-table-column>
            <el-table-column
              prop="noDelivery"
              label=" Reserve warehousing/Undelivered quantity"
              width="180"
            >
              <template
                slot-scope="scope"
                v-if="scope.row.AsnDetail"
              >{{scope.row.noDelivery }} / {{scope.row.receivedQty}}</template>
            </el-table-column>
            <el-table-column prop="QCDetail" label="Qualified/unqualified quantity" width="180">
              <template
                slot-scope="scope"
                v-if="scope.row.AsnDetail"
              >{{scope.row.passQty}} / {{scope.row.nopassQty }}</template>
            </el-table-column>
            <el-table-column label="Operation" width="180" fixed="right">
              <template slot-scope="scope">
                <a @click="Details(scope)">Details</a>
                <a
                  @click="Reshipment(scope)"
                  v-if="scope.row.AsnStatu==0||scope.row.AsnStatu==2||scope.row.AsnStatu==1"
                >
                  <span v-if="scope.row.deliverWay==2">
                    <span v-if="scope.row.trackingInformation"><span v-if="scope.row.trackingInformation.trackingNumber==''">Reshipment no</span></span>
                    
                  </span>
                </a>
              </template>
            </el-table-column>
          </el-table>

          <el-pagination
            class="pagination"
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange1"
            :current-page="currentPage"
            background
            :page-size="10"
            layout="total,  prev, pager, next, jumper"
            :total="total"
          ></el-pagination>
        </el-tab-pane>
        <el-tab-pane name="Processing">
          <span slot="label">
            Processing
            <el-badge :value="countProcessing" size="mini" class="item"></el-badge>
          </span>

          <el-table
            ref="multipleTable"
            :data="tableData"
            border
            style="width: 100%"
            v-loading="loading"
          >
            <!-- <el-table-column type="selection" width="60" fixed="left"></el-table-column> -->
            <el-table-column prop="AsnCreateTime" label="Creation time" width="100">
              <!-- <template slot-scope="scope">
                <img :src="scope.row.eNumber" min-width="70" height="70">
              </template>-->
            </el-table-column>
            <el-table-column prop="AsnCode" label="ASN number" show-overflow-tooltip></el-table-column>
            <el-table-column prop="refCode" label="Reference No"></el-table-column>
            <el-table-column prop="AsnDetail" label="SKU number">
              <template slot-scope="scope" v-if="scope.row.AsnDetail">
                <span v-if="scope.row.AsnDetail.length>0">{{scope.row.AsnDetail.length}}</span>
                <span v-else>1</span>
              </template>
            </el-table-column>
            <el-table-column prop="warehouseId" label="Warehouse" width="180">
              <template slot-scope="scope" v-if="scope.row.warehouseId=='4'">SHENZHEN02</template>
              <template slot-scope="scope" v-else-if="scope.row.warehouseId=='5'">香港仓</template>
            </el-table-column>
            <el-table-column
              prop="noDelivery"
              label=" Reserve warehousing/Undelivered quantity"
              width="180"
            >
              <template
                slot-scope="scope"
                v-if="scope.row.AsnDetail"
              >{{scope.row.noDelivery }} / {{scope.row.receivedQty}}</template>
            </el-table-column>
            <el-table-column prop="AsnDetail" label="Qualified/unqualified quantity" width="180">
              <template
                slot-scope="scope"
                v-if="scope.row.AsnDetail"
              >{{scope.row.passQty}} / {{scope.row.nopassQty }}</template>
            </el-table-column>
            <el-table-column label="Operation" width="180" fixed="right">
              <template slot-scope="scope">
                <a @click="Details(scope)">Details</a>
                <a
                  @click="Reshipment(scope)"
                  v-if="scope.row.AsnStatu==0||scope.row.AsnStatu==2||scope.row.AsnStatu==1"
                >
                  <span v-if="scope.row.deliverWay==2">
                      <span v-if="scope.row.trackingInformation"><span v-if="scope.row.trackingInformation.trackingNumber==''">Reshipment no</span></span>
                  </span>
                </a>
              </template>
            </el-table-column>
          </el-table>

          <el-pagination
            class="pagination"
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange2"
            :current-page="currentPage"
            background
            :page-size="10"
            layout="total,  prev, pager, next, jumper"
            :total="total"
          ></el-pagination>
        </el-tab-pane>
        <el-tab-pane name="Completed">
          <span slot="label">
            Completed
            <el-badge :value="countCompeleted" size="mini" class="item"></el-badge>
          </span>

          <el-table
            ref="multipleTable"
            :data="tableData"
            border
            style="width: 100%"
            v-loading="loading"
          >
            <!-- <el-table-column type="selection" width="60" fixed="left"></el-table-column> -->
            <el-table-column prop="AsnCreateTime" label="Creation time" width="100">
              <!-- <template slot-scope="scope">
                <img :src="scope.row.eNumber" min-width="70" height="70">
              </template>-->
            </el-table-column>
            <el-table-column prop="AsnCode" label="ASN number" show-overflow-tooltip></el-table-column>
            <el-table-column prop="refCode" label="Reference No"></el-table-column>
            <el-table-column prop="AsnDetail" label="SKU number">
              <template slot-scope="scope" v-if="scope.row.AsnDetail">
                <span v-if="scope.row.AsnDetail.length>0">{{scope.row.AsnDetail.length}}</span>
                <span v-else>1</span>
              </template>
            </el-table-column>
            <el-table-column prop="warehouseId" label="Warehouse" width="180">
              <template slot-scope="scope" v-if="scope.row.warehouseId=='4'">SHENZHEN02</template>
              <template slot-scope="scope" v-else-if="scope.row.warehouseId=='5'">香港仓</template>
            </el-table-column>
            <el-table-column
              prop="noDelivery"
              label=" Reserve warehousing/Undelivered quantity"
              width="180"
            >
              <template
                slot-scope="scope"
                v-if="scope.row.AsnDetail"
              >{{scope.row.noDelivery }} / {{scope.row.receivedQty}}</template>
            </el-table-column>
            <el-table-column prop="QCDetail" label="Qualified/unqualified quantity" width="180">
              <template
                slot-scope="scope"
                v-if="scope.row.AsnDetail"
              >{{scope.row.passQty}} / {{scope.row.nopassQty }}</template>
            </el-table-column>
            <el-table-column label="Operation" width="180" fixed="right">
              <template slot-scope="scope">
                <a @click="Details(scope)">Details</a>
                <a
                  @click="Reshipment(scope)"
                  v-if="scope.row.AsnStatu==0||scope.row.AsnStatu==2||scope.row.AsnStatu==1"
                >
                  <span v-if="scope.row.deliverWay==2">
                      <span v-if="scope.row.trackingInformation"><span v-if="scope.row.trackingInformation.trackingNumber==''">Reshipment no</span></span>
                  </span>
                </a>
              </template>
            </el-table-column>
          </el-table>

          <el-pagination
            class="pagination"
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange3"
            :current-page="currentPage"
            background
            :page-size="10"
            layout="total,  prev, pager, next, jumper"
            :total="total"
          ></el-pagination>
        </el-tab-pane>
        <el-tab-pane name="harvest">
          <span slot="label">
            Batch harvest
            <el-badge :value="countBatchHarvest" size="mini" class="item"></el-badge>
          </span>
          <el-table
            ref="multipleTable"
            :data="tableData"
            border
            style="width: 100%"
            v-loading="loading"
          >
            <!-- <el-table-column type="selection" width="60" fixed="left"></el-table-column> -->
            <el-table-column prop="AsnCreateTime" label="Creation time" width="100">
              <!-- <template slot-scope="scope">
                <img :src="scope.row.eNumber" min-width="70" height="70">
              </template>-->
            </el-table-column>
            <el-table-column prop="AsnCode" label="ASN number" show-overflow-tooltip></el-table-column>
            <el-table-column prop="refCode" label="Reference No"></el-table-column>
            <el-table-column prop="AsnDetail" label="SKU number">
              <template slot-scope="scope" v-if="scope.row.AsnDetail">
                <span v-if="scope.row.AsnDetail.length>0">{{scope.row.AsnDetail.length}}</span>
                <span v-else>1</span>
              </template>
            </el-table-column>
            <el-table-column prop="warehouseId" label="Warehouse" width="180">
              <template slot-scope="scope" v-if="scope.row.warehouseId=='4'">SHENZHEN02</template>
              <template slot-scope="scope" v-else-if="scope.row.warehouseId=='5'">香港仓</template>
            </el-table-column>
            <el-table-column
              prop="noDelivery"
              label=" Reserve warehousing/Undelivered quantity"
              width="180"
            >
              <template
                slot-scope="scope"
                v-if="scope.row.AsnDetail"
              >{{scope.row.noDelivery }} / {{scope.row.receivedQty}}</template>
            </el-table-column>
            <el-table-column prop="QCDetail" label="Qualified/unqualified quantity" width="180">
              <template
                slot-scope="scope"
                v-if="scope.row.AsnDetail"
              >{{scope.row.passQty}} / {{scope.row.nopassQty }}</template>
            </el-table-column>
            <el-table-column label="Operation" width="180" fixed="right">
              <template slot-scope="scope">
                <a @click="Details(scope)">Details</a>
                <a
                  @click="Reshipment(scope)"
                  v-if="scope.row.AsnStatu==0||scope.row.AsnStatu==2||scope.row.AsnStatu==1"
                >
                  <span v-if="scope.row.deliverWay==2">
                      <span v-if="scope.row.trackingInformation"><span v-if="scope.row.trackingInformation.trackingNumber==''">Reshipment no</span></span>
                  </span>
                </a>
              </template>
            </el-table-column>
          </el-table>

          <el-pagination
            class="pagination"
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange4"
            :current-page="currentPage"
            background
            :page-size="10"
            layout="total,  prev, pager, next, jumper"
            :total="total"
          ></el-pagination>
        </el-tab-pane>
        <el-tab-pane name="Deleted">
          <span slot="label">
            Deleted
            <el-badge :value="countDeleted" size="mini" class="item"></el-badge>
          </span>
          <el-table
            ref="multipleTable"
            :data="tableData"
            border
            style="width: 100%"
            v-loading="loading"
          >
            <el-table-column prop="AsnCreateTime" label="Creation time" width="100"></el-table-column>
            <el-table-column prop="AsnCode" label="ASN number" show-overflow-tooltip></el-table-column>
            <el-table-column prop="refCode" label="Reference No"></el-table-column>
            <el-table-column prop="AsnDetail" label="SKU number">
              <template slot-scope="scope" v-if="scope.row.AsnDetail">
                <span v-if="scope.row.AsnDetail.length>0">{{scope.row.AsnDetail.length}}</span>
                <span v-else>1</span>
              </template>
            </el-table-column>
            <el-table-column prop="warehouseId" label="Warehouse" width="180">
              <template slot-scope="scope" v-if="scope.row.warehouseId=='4'">SHENZHEN02</template>
              <template slot-scope="scope" v-else-if="scope.row.warehouseId=='5'">香港仓</template>
            </el-table-column>
            <el-table-column
              prop="noDelivery"
              label=" Reserve warehousing/Undelivered quantity"
              width="180"
            >
              <template
                slot-scope="scope"
                v-if="scope.row.AsnDetail"
              >{{scope.row.noDelivery }} / {{scope.row.receivedQty}}</template>
            </el-table-column>
            <el-table-column prop="QCDetail" label="Qualified/unqualified quantity" width="180">
              <template
                slot-scope="scope"
                v-if="scope.row.AsnDetail"
              >{{scope.row.passQty}} / {{scope.row.nopassQty }}</template>
            </el-table-column>
            <el-table-column label="Operation" width="180" fixed="right">
              <template slot-scope="scope">
                <a @click="Details(scope)">Details</a>
                <a
                  @click="Reshipment(scope)"
                  v-if="scope.row.AsnStatu==0||scope.row.AsnStatu==2||scope.row.AsnStatu==1"
                >
                  <span v-if="scope.row.deliverWay==2">
                      <span v-if="scope.row.trackingInformation"><span v-if="scope.row.trackingInformation.trackingNumber==''">Reshipment no</span></span>
                  </span>
                </a>
              </template>
            </el-table-column>
          </el-table>
          <el-pagination
            class="pagination"
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange5"
            :current-page="currentPage"
            background
            :page-size="10"
            layout="total,  prev, pager, next, jumper"
            :total="total"
          ></el-pagination>
        </el-tab-pane>
      </el-tabs>
      <el-dialog
        title="Please fill in the waybill number"
        :visible.sync="waybillnumberVisible"
        center
        width="400px"
        :close-on-click-modal="false"
        :before-close="handleDialogClose"
      >
        <el-form :model="form" ref="form" @submit.native.prevent>
          <el-form-item prop="Amount">
            <el-select
              v-model="form.region"
              style="width:100%"
              placeholder="Choose a logistics company"
            >
              <el-option
                v-for="(item,index) in carriername"
                :key="item"
                :label="item"
                :value="index"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item prop="Amount">
            <el-input
              type="Amount"
              v-model.number="form.Amount"
              autocomplete="off"
              placeholder="Please enter the amount of recharge"
            ></el-input>
          </el-form-item>
        </el-form>
        <div slot="footer" class="dialog-footer">
          <!-- <el-button @click="handleDialogClose">取 消</el-button> -->
          <el-button
            type="primary"
            style="background:#8989ba;color:#fff;outline: none"
            @click="subnumber"
          >Confirm</el-button>
        </div>
      </el-dialog>
      <Ans-details
        :visible="addVisible"
        :AsnCode="AsnCode"
        :companyList="companyList"
        @clearAdd="clearAdd"
      ></Ans-details>
    </div>
  </div>
</template>
<script>
//import { getorderdata } from "../api/OrderManagement";
import { setItem, getItem } from "../../utils/locstorage";
import { getToken } from "../../utils/auth";
import Ansdetails from "./Ansdetails/Ansdetails";
import {
  asnshipping,
  getasnlist,
  getasnstatuscount,
  getasndetail,
  updatetracking
} from "../api/ans";
export default {
  components: {
    "Ans-details": Ansdetails
  },
  data() {
    return {
      AsnCode: "",
      loading: true,
      companyList: {
        asnInf: {},
        asnItem: {},
        trackingInformation: {}
      },
      asn_code: "",
      statu: "",
      countUnReceiveing: "0",
      countBatchHarvest: "0",
      countCompeleted: "0",
      countDeleted: "0",
      countProcessing: "0",
      addVisible: false,
      waybillnumberVisible: false,
      activeName: "",
      total: 50,
      carriername: "",
      Queryproductval: "",
      currentPage: 1,
      pageSize: 10,
      tableData: [],
      formLabelWidth: "120px",
      multipleSelection: [],
      Batchoperationvalue: "",
      form: {}
    };
  },
  created: function() {
    // 组件创建完后获取数据，
    // 此时 data 已经被 observed 了
    //this.fetchData();
  },
  mounted() {
    
    let param = { asn_status: 2 };
    getasnlist(param)
      .then(response => {
        this.loading = false;
        console.log(response);
        if (response.data.ask == 1) {
          let tableData;
          this.getcount();
          this.asnshippin();
          console.log(response.data.data.constructor === Array);
          if (response.data.data.constructor === Array) {
            tableData = response.data.data;
            for (let i = 0; i < tableData.length; i++) {
              if (tableData[i].AsnDetail) {
                tableData[i].nopassQty = 0;
                tableData[i].noDelivery = 0;
                tableData[i].receivedQty = 0;
                tableData[i].passQty = 0;
                if (tableData[i].AsnDetail.constructor === Array) {
                  for (let j = 0; j < tableData[i].AsnDetail.length; j++) {
                    tableData[i].nopassQty += Number(
                      tableData[i].AsnDetail[j].nopassQty
                    );
                    tableData[i].noDelivery += Number(
                      tableData[i].AsnDetail[j].orderQty
                    );
                    tableData[i].receivedQty += Number(
                      tableData[i].AsnDetail[j].noDelivery1
                    );

                    tableData[i].passQty += Number(
                      tableData[i].AsnDetail[j].passQty
                    );
                  }
                } else {
                  tableData[i].nopassQty = Number(
                    tableData[i].AsnDetail.nopassQty
                  );
                  tableData[i].noDelivery = Number(
                    tableData[i].AsnDetail.orderQty
                  );
                  tableData[i].receivedQty = Number(
                    tableData[i].AsnDetail.noDelivery1
                  );
                  tableData[i].passQty = Number(tableData[i].AsnDetail.passQty);
                }
              }
            }
            this.tableData = tableData;
          } else {
            let tableData = [];
            tableData.push(response.data.data);

            for (let i = 0; i < tableData.length; i++) {
              if (tableData[i].AsnDetail) {
                if (tableData[i].AsnDetail.constructor === Array) {
                  tableData[i].nopassQty = 0;
                  tableData[i].passQty = 0;
                  tableData[i].noDelivery = 0;
                  tableData[i].receivedQty = 0;
                  for (let j = 0; j < tableData[i].AsnDetail.length; j++) {
                    tableData[i].nopassQty += Number(
                      tableData[i].AsnDetail[j].nopassQty
                    );
                    tableData[i].noDelivery += Number(
                      tableData[i].AsnDetail[j].orderQty
                    );
                    tableData[i].receivedQty += Number(
                      tableData[i].AsnDetail[j].noDelivery1
                    );
                    tableData[i].passQty += Number(
                      tableData[i].AsnDetail[j].passQty
                    );
                  }
                } else {
                  tableData[i].nopassQty = Number(
                    tableData[i].AsnDetail.nopassQty
                  );
                  tableData[i].noDelivery = Number(
                    tableData[i].AsnDetail.orderQty
                  );
                  tableData[i].receivedQty = Number(
                    tableData[i].AsnDetail.noDelivery1
                  );
                  tableData[i].passQty = Number(tableData[i].AsnDetail.passQty);
                }
              }
            }
            this.tableData = tableData;
          }
        } else {
          if(response.data.msg!="need login"){
            this.getcount();
          this.asnshippin();
          }
          this.loading = false;
        }
      })
      .catch(error => {
        this.loading = false;
        console.log(error);
      });

    
  },

  methods: {
  asnshippin(){
  asnshipping()
      .then(response => {
        console.log(response);

        if (response.data.ask == 1) {
          console.log(response.data.data);
          this.carriername = response.data.data;
          console.log(this.carriername);
        }
      })
      .catch(error => {
        console.log(error);
      });


  },
    
    getcount() {
      getasnstatuscount()
        .then(response => {
          if (response.data.ask == 1) {
            console.log(response);
            this.countUnReceiveing = response.data.data.countUnReceiveing;
            this.countBatchHarvest = response.data.data.countBatchHarvest;
            this.countCompeleted = response.data.data.countCompeleted;
            this.countDeleted = response.data.data.countDeleted;
            this.countProcessing = response.data.data.countProcessing;
            console.log(this.countUnReceiveing);
            this.total = Number(response.data.data.countUnReceiveing);
            this.activeName = "";
            setTimeout(() => {
              this.activeName = "Unreceived";
            }, 100);
          }
        })
        .catch(error => {
          console.log(error);
        });
    },
    //查询商品
    Queryproduct() {
      this.loading = true;
      console.log(this.Queryproductval);
      if (this.Queryproductval != "") {
        let param = {
          asn_code: this.Queryproductval
        };
        getasnlist(param)
          .then(response => {
            this.loading = false;
            console.log(response);
            if (response.data.ask == 1) {
              let tableData = [];
              tableData.push(response.data.data);

              //tableData=response.data.data;
              for (let i = 0; i < tableData.length; i++) {
                if (tableData[i].AsnDetail) {
                  if (tableData[i].AsnDetail.constructor === Array) {
                    tableData[i].nopassQty = 0;
                    tableData[i].passQty = 0;
                    tableData[i].noDelivery = 0;
                    tableData[i].receivedQty = 0;
                    for (let j = 0; j < tableData[i].AsnDetail.length; j++) {
                      tableData[i].nopassQty += Number(
                        tableData[i].AsnDetail[j].nopassQty
                      );
                      tableData[i].passQty += Number(
                        tableData[i].AsnDetail[j].passQty
                      );
                      tableData[i].noDelivery += Number(
                        tableData[i].AsnDetail[j].orderQty
                      );
                      tableData[i].receivedQty += Number(
                        tableData[i].AsnDetail[j].noDelivery1
                      );
                    }
                  } else {
                    tableData[i].nopassQty = Number(
                      tableData[i].AsnDetail.nopassQty
                    );
                    tableData[i].noDelivery = Number(
                      tableData[i].AsnDetail.orderQty
                    );
                    tableData[i].receivedQty = Number(
                      tableData[i].AsnDetail.noDelivery1
                    );
                    tableData[i].passQty = Number(
                      tableData[i].AsnDetail.passQty
                    );
                  }
                }
              }
              this.tableData = tableData;
              console.log(this.tableData);

              this.total = tableData.length;
              //this.tableData = tableData;
              this.activeName = "";
              if (response.data.data.AsnStatu == 2) {
                setTimeout(() => {
                  this.activeName = "Unreceived";
                }, 100);
                this.countUnReceiveing = "1";
                (this.countProcessing = "0"),
                  (this.countDeleted = "0"),
                  (this.countCompeleted = "0"),
                  (this.countBatchHarvest = "0");
              } else if (
                response.data.data.AsnStatu == 4 ||
                response.data.data.AsnStatu == 3 ||
                response.data.data.AsnStatu == 5
              ) {
                setTimeout(() => {
                  this.activeName = "Processing";
                }, 100);
                this.countUnReceiveing = "0";
                (this.countProcessing = "1"),
                  (this.countDeleted = "0"),
                  (this.countCompeleted = "0"),
                  (this.countBatchHarvest = "0");
              } else if (response.data.data.AsnStatu == 6) {
                setTimeout(() => {
                  this.activeName = "Completed";
                }, 100);
                this.countUnReceiveing = "0";
                (this.countProcessing = "0"),
                  (this.countDeleted = "0"),
                  (this.countCompeleted = "1"),
                  (this.countBatchHarvest = "0");
              } else if (response.data.data.AsnStatu == 7) {
                setTimeout(() => {
                  this.activeName = "harvest";
                }, 100);
                this.countUnReceiveing = "0";
                (this.countProcessing = "0"),
                  (this.countDeleted = "0"),
                  (this.countCompeleted = "0"),
                  (this.countBatchHarvest = "1");
              } else if (response.data.data.AsnStatu == 0) {
                setTimeout(() => {
                  this.activeName = "Deleted";
                }, 100);
                this.countUnReceiveing = "0";
                (this.countProcessing = "0"),
                  (this.countDeleted = "1"),
                  (this.countCompeleted = "0"),
                  (this.countBatchHarvest = "0");
              }
            } else {
              this.loading = false;
              this.tableData = [];
            }
          })
          .catch(error => {
            this.loading = false;
            console.log(error);
          });
      } else {
        this.getcount();
        let param = { asn_status: 2 };
        getasnlist(param)
          .then(response => {
            this.loading = false;
            console.log(response);
            let tableData;
            if (response.data.ask == 1) {
              console.log(response.data.data.constructor === Array);
              if (response.data.data.constructor === Array) {
                tableData = response.data.data;
                for (let i = 0; i < tableData.length; i++) {
                  if (tableData[i].AsnDetail) {
                    if (tableData[i].AsnDetail.constructor === Array) {
                      tableData[i].nopassQty = 0;
                      tableData[i].passQty = 0;
                      tableData[i].noDelivery = 0;
                      tableData[i].receivedQty = 0;
                      for (
                        let j = 0;
                        j < response.data.data[i].AsnDetail.length;
                        j++
                      ) {
                        tableData[i].nopassQty += Number(
                          tableData[i].AsnDetail[j].nopassQty
                        );

                        tableData[i].passQty += Number(
                          tableData[i].AsnDetail[j].passQty
                        );
                        tableData[i].noDelivery += Number(
                          tableData[i].AsnDetail[j].orderQty
                        );
                        tableData[i].receivedQty += Number(
                          tableData[i].AsnDetail[j].noDelivery1
                        );
                      }
                    } else {
                      tableData[i].nopassQty = Number(
                        tableData[i].AsnDetail.nopassQty
                      );
                      tableData[i].noDelivery = Number(
                        tableData[i].AsnDetail.orderQty
                      );
                      tableData[i].receivedQty = Number(
                        tableData[i].AsnDetail.noDelivery1
                      );
                      tableData[i].passQty = Number(
                        tableData[i].AsnDetail.passQty
                      );
                    }
                  }
                }
                this.tableData = tableData;
                console.log(this.tableData);
              } else {
                let tableData = [];
                tableData.push(response.data.data);

                for (let i = 0; i < tableData.length; i++) {
                  if (tableData[i].AsnDetail) {
                    if (tableData[i].AsnDetail.constructor === Array) {
                      tableData[i].nopassQty = 0;
                      tableData[i].passQty = 0;
                      tableData[i].noDelivery = 0;
                      tableData[i].receivedQty = 0;
                      for (let j = 0; j < tableData[i].AsnDetail.length; j++) {
                        tableData[i].nopassQty += Number(
                          tableData[i].AsnDetail[j].nopassQty
                        );
                        tableData[i].passQty += Number(
                          tableData[i].AsnDetail[j].passQty
                        );
                        tableData[i].noDelivery += Number(
                          tableData[i].AsnDetail[j].orderQty
                        );
                        tableData[i].receivedQty += Number(
                          tableData[i].AsnDetail[j].noDelivery1
                        );
                      }
                    } else {
                      tableData[i].nopassQty = Number(
                        tableData[i].AsnDetail.nopassQty
                      );
                      tableData[i].noDelivery = Number(
                        tableData[i].AsnDetail.orderQty
                      );
                      tableData[i].receivedQty = Number(
                        tableData[i].AsnDetail.noDelivery1
                      );
                      tableData[i].passQty = Number(
                        tableData[i].AsnDetail.passQty
                      );
                    }
                  }
                }
                this.tableData = tableData;
              }
            } else {
              this.loading = false;
              
            }
          })
          .catch(error => {
            this.loading = false;
            console.log(error);
          });

        this.asnshippin()
      }
    },
    handleClick(tab, event) {
      console.log(tab);
      //let statu;

      getasnstatuscount()
        .then(response => {
          if (response.data.ask == 1) {
            console.log(response);
            if (this.Queryproductval == "") {
              this.countUnReceiveing = response.data.data.countUnReceiveing;
              this.countBatchHarvest = response.data.data.countBatchHarvest;
              this.countCompeleted = response.data.data.countCompeleted;
              this.countDeleted = response.data.data.countDeleted;
              this.countProcessing = response.data.data.countProcessing;
              console.log(this.countUnReceiveing);
              if (tab.index == 0) {
                this.statu = 2;
                this.total = Number(this.countUnReceiveing);
              } else if (tab.index == 1) {
                this.total = Number(this.countProcessing);
                this.statu = "3,4,5";
              } else if (tab.index == 2) {
                this.total = Number(this.countCompeleted);
                this.statu = 6;
              } else if (tab.index == 3) {
                this.total = Number(this.countBatchHarvest);
                this.statu = 7;
              } else if (tab.index == 4) {
                this.total = Number(this.countDeleted);
                this.statu = 0;
              }
              let param = {
                asn_status: this.statu,
                asn_code: this.Queryproductval
              };
              this.list(param);
            } else {
              if (tab.index == 0) {
                this.statu = 2;
                this.total = Number(this.countUnReceiveing);
              } else if (tab.index == 1) {
                this.total = Number(this.countProcessing);
                this.statu = "3,4,5";
              } else if (tab.index == 2) {
                this.total = Number(this.countCompeleted);
                this.statu = 6;
              } else if (tab.index == 3) {
                this.total = Number(this.countBatchHarvest);
                this.statu = 7;
              } else if (tab.index == 4) {
                this.total = Number(this.countDeleted);
                this.statu = 0;
              }
              let param = {
                asn_status: this.statu,
                asn_code: this.Queryproductval
              };
              this.list(param);
            }

            //this.activeName = "Unreceived";
          }
        })
        .catch(error => {
          console.log(error);
        });
    },
    list(param) {
      this.loading = true;
      getasnlist(param)
        .then(response => {
          console.log(response);
          this.loading = false;
          let tableData;
          if (response.data.ask == 1) {
            console.log(response.data.data.constructor === Array);
            if (response.data.data.constructor === Array) {
              tableData = response.data.data;
              for (let i = 0; i < tableData.length; i++) {
                if (tableData[i].AsnDetail) {
                  tableData[i].nopassQty = 0;
                  tableData[i].passQty = 0;
                  tableData[i].noDelivery = 0;
                  tableData[i].receivedQty = 0;
                  if (tableData[i].AsnDetail.constructor === Array) {
                    for (let j = 0; j < tableData[i].AsnDetail.length; j++) {
                      tableData[i].nopassQty += Number(
                        tableData[i].AsnDetail[j].nopassQty
                      );

                      tableData[i].passQty += Number(
                        tableData[i].AsnDetail[j].passQty
                      );
                      tableData[i].noDelivery += Number(
                        tableData[i].AsnDetail[j].orderQty
                      );
                      tableData[i].receivedQty += Number(
                        tableData[i].AsnDetail[j].noDelivery1
                      );
                    }
                  } else {
                    tableData[i].nopassQty = Number(
                      tableData[i].AsnDetail.nopassQty
                    );
                    tableData[i].noDelivery = Number(
                      tableData[i].AsnDetail.orderQty
                    );
                    tableData[i].receivedQty = Number(
                      tableData[i].AsnDetail.noDelivery1
                    );
                    tableData[i].passQty = Number(
                      tableData[i].AsnDetail.passQty
                    );
                  }
                }
              }
              this.tableData = tableData;
            } else {
              let tableData = [];
              tableData.push(response.data.data);
              for (let i = 0; i < tableData.length; i++) {
                if (tableData[i].AsnDetail) {
                  if (tableData[i].AsnDetail.constructor === Array) {
                    tableData[i].nopassQty = 0;
                    tableData[i].passQty = 0;
                    tableData[i].noDelivery = 0;
                    tableData[i].receivedQty = 0;
                    for (let j = 0; j < tableData[i].AsnDetail.length; j++) {
                      tableData[i].nopassQty += Number(
                        tableData[i].AsnDetail[j].nopassQty
                      );
                      tableData[i].passQty += Number(
                        tableData[i].AsnDetail[j].passQty
                      );
                      tableData[i].noDelivery += Number(
                        tableData[i].AsnDetail[j].orderQty
                      );
                      tableData[i].receivedQty += Number(
                        tableData[i].AsnDetail[j].noDelivery1
                      );
                    }
                  } else {
                    tableData[i].nopassQty = Number(
                      tableData[i].AsnDetail.nopassQty
                    );
                    tableData[i].noDelivery = Number(
                      tableData[i].AsnDetail.orderQty
                    );
                    tableData[i].receivedQty = Number(
                      tableData[i].AsnDetail.noDelivery1
                    );
                    tableData[i].passQty = Number(
                      tableData[i].AsnDetail.passQty
                    );
                  }
                }
              }
              this.tableData = tableData;
            }
          } else {
            this.tableData = [];
            
          }
        })
        .catch(error => {
          this.loading = false;
          console.log(error);
        });
    },

    //分页
    handleSizeChange(val) {
      this.pageSize = val;
      this.currentPage = 1;
      //this.fetchData(1, val);

      //  let param = { asn_status: statu,};
      //    this.list(param);
      console.log(`每页 ${val} 条`);
    },
    handleCurrentChange1(val) {
      this.currentPage = val;
      let param = { asn_status: 2, current_page: val };
      this.list(param);
      //this.fetchData(val, this.pageSize);
      // console.log(`当前页: ${val}`);
    },
    handleCurrentChange2(val) {
      this.currentPage = val;
      let param = { asn_status: "3,4,5", current_page: val };
      this.list(param);
      //this.fetchData(val, this.pageSize);
      // console.log(`当前页: ${val}`);
    },
    handleCurrentChange3(val) {
      this.currentPage = val;
      let param = { asn_status: 6, current_page: val };
      this.list(param);
      //this.fetchData(val, this.pageSize);
      // console.log(`当前页: ${val}`);
    },
    handleCurrentChange4(val) {
      this.currentPage = val;
      let param = { asn_status: 7, current_page: val };
      this.list(param);
      //this.fetchData(val, this.pageSize);
      // console.log(`当前页: ${val}`);
    },
    handleCurrentChange5(val) {
      this.currentPage = val;
      let param = { asn_status: 0, current_page: val };
      this.list(param);
      //this.fetchData(val, this.pageSize);
      // console.log(`当前页: ${val}`);
    },
    Details(scope) {
      console.log(scope);
      let AsnDetail;
      if (scope.row.AsnDetail) {
        if (scope.row.AsnDetail.constructor === Array) {
          AsnDetail = scope.row.AsnDetail;
        } else {
          let AsnDetail1 = [];
          AsnDetail1.push(scope.row.AsnDetail);
          AsnDetail = AsnDetail1;
        }
      } else {
        AsnDetail = [];
      }

      let param = {
        asn_code: scope.row.AsnCode
      };
      getasndetail(param)
        .then(response => {
          console.log(response);
          if (response.data.ask == 1) {
            if (response.data.data.asnItem.constructor === Array) {
              if (response.data.data.specialService) {
                if (response.data.data.specialService.constructor === Array) {
                  console.log(response.data.data.specialService);
                  let data1 = [];
                  let datan = {};
                  for (
                    let i = 0;
                    i < response.data.data.specialService.length;
                    i++
                  ) {
                    for (
                      let j = 0;
                      j < response.data.data.asnItem.length;
                      j++
                    ) {
                      if (
                        response.data.data.asnItem[j].sku ==
                        response.data.data.specialService[i].sku
                      ) {
                        console.log(response.data.data.specialService[i]);
                        if (!datan[response.data.data.specialService[i].sku]) {
                          datan[response.data.data.specialService[i].sku] = [];
                          datan[response.data.data.specialService[i].sku][0] =
                            response.data.data.specialService[i];
                        } else {
                          datan[response.data.data.specialService[i].sku][
                            datan[
                              response.data.data.specialService[i].sku
                            ].length
                          ] = response.data.data.specialService[i];
                        }
                        data1.push(
                          datan[response.data.data.specialService[i].sku]
                        );
                      }
                    }
                  }
                  for (let i = 0; i < data1.length; i++) {
                    if (data1.indexOf(data1[i]) != i) {
                      data1.splice(i, 1);
                      i--;
                    }
                  }
                  let spo_code = [];
                  for (let i = 0; i < data1.length; i++) {
                    for (let j = 0; j < data1[i].length; j++) {
                      if (spo_code[i]) {
                        spo_code[i] += data1[i][j].spo_code + ",";
                      } else {
                        spo_code[i] = "";
                        spo_code[i] += data1[i][j].spo_code + ",";
                      }
                    }
                    let reg = /,$/gi;
                    spo_code[i] = spo_code[i].replace(reg, "");
                    data1[i].ss = spo_code[i];
                  }

                  console.log(data1);
                  this.AsnCode = scope.row.AsnCode;
                  let tnha = response.data.data;
                  let Quantity = 0,
                    weight = 0,
                    price = 0;
                  let SPCode = scope.row.SPCode;
                  for (let i = 0; i < response.data.data.asnItem.length; i++) {
                    Quantity += Number(response.data.data.asnItem[i].quantity);
                    weight +=
                      Number(response.data.data.asnItem[i].weight) *
                      Number(response.data.data.asnItem[i].quantity);
                    price +=
                      Number(
                        response.data.data.asnItem[i].productDeclarationValue
                      ) * Number(response.data.data.asnItem[i].quantity);
                  }

                  let asnItem = response.data.data.asnItem;
                  // asnItem.push(response.data.data.asnItem);

                  for (let i = 0; i < asnItem.length; i++) {
                    for (let j = 0; j < AsnDetail.length; j++) {
                      if (asnItem[i].sku == AsnDetail[j].sku) {
                        asnItem[i].quantity = Number(asnItem[i].quantity);
                        asnItem[i].problemQuantity = Number(
                          AsnDetail[j].nopassQty
                        );
                        asnItem[i].receivedQty = Number(
                          AsnDetail[j].receivedQty
                        );
                        asnItem[i].orderQty = Number(AsnDetail[j].orderQty);
                        asnItem[i].putawayQuantity = Number(
                          AsnDetail[j].passQty
                        );
                         asnItem[i].isEdit = Number(
                          AsnDetail[j].isEdit
                        );
                      }
                    }
                  }
                  tnha.asnItem = asnItem;
                  tnha.Quantity = Quantity;
                  tnha.weight = weight;
                  tnha.price = price;
                  tnha.SPCode = SPCode;
                  tnha.specialService = data1;
                  tnha.specia = true;
                  tnha.AsnDetail = AsnDetail;
                  console.log(tnha);
                  this.companyList = tnha;
                  this.addVisible = true;
                } else {
                  // let Quantity = response.data.data.asnItem.quantity;
                  // let weight = response.data.data.asnItem.weight;
                  // let price =
                  //   response.data.data.asnItem.productDeclarationValue;
                  // let SPCode = scope.row.SPCode;
                  
                  let tnha = response.data.data;
                  let Quantity = 0,
                    weight = 0,
                    price = 0;
                  let SPCode = scope.row.SPCode;
                  for (let i = 0; i < response.data.data.asnItem.length; i++) {
                    Quantity += Number(response.data.data.asnItem[i].quantity);
                    weight +=
                      Number(response.data.data.asnItem[i].weight) *
                      Number(response.data.data.asnItem[i].quantity);
                    price +=
                      Number(
                        response.data.data.asnItem[i].productDeclarationValue
                      ) * Number(response.data.data.asnItem[i].quantity);
                  }

                  let specialService = [];
                  let asnItem = response.data.data.asnItem;
                 // asnItem.push(response.data.data.asnItem);

                  for (let i = 0; i < asnItem.length; i++) {
                    for (let j = 0; j < AsnDetail.length; j++) {
                      if (asnItem[i].sku == AsnDetail[j].sku) {
                        asnItem[i].quantity = Number(asnItem[i].quantity);
                        asnItem[i].problemQuantity = Number(
                          AsnDetail[j].nopassQty
                        );
                        asnItem[i].receivedQty = Number(
                          AsnDetail[j].receivedQty
                        );
                        asnItem[i].orderQty = Number(AsnDetail[j].orderQty);
                        asnItem[i].putawayQuantity = Number(
                          AsnDetail[j].passQty
                        );
                        asnItem[i].isEdit = Number(
                          AsnDetail[j].isEdit
                        );
                      }
                    }
                  }
                  specialService.push(response.data.data.specialService);
                   console.log(response.data.data.specialService);
                  let data1 = [];
                  let datan = {};
                  for (
                    let i = 0;
                    i < specialService.length;
                    i++
                  ) {
                    for (
                      let j = 0;
                      j < response.data.data.asnItem.length;
                      j++
                    ) {
                      if (
                        response.data.data.asnItem[j].sku ==
                        specialService[i].sku
                      ) {
                        console.log(specialService[i]);
                        if (!datan[specialService[i].sku]) {
                          datan[specialService[i].sku] = [];
                          datan[specialService[i].sku][0] =
                            specialService[i];
                        } else {
                          datan[specialService[i].sku][
                            datan[
                              specialService[i].sku
                            ].length
                          ] = specialService[i];
                        }
                        data1.push(
                          datan[specialService[i].sku]
                        );
                      }
                    }
                  }
                  for (let i = 0; i < data1.length; i++) {
                    if (data1.indexOf(data1[i]) != i) {
                      data1.splice(i, 1);
                      i--;
                    }
                  }
                  let spo_code = [];
                  for (let i = 0; i < data1.length; i++) {
                    for (let j = 0; j < data1[i].length; j++) {
                      if (spo_code[i]) {
                        spo_code[i] += data1[i][j].spo_code + ",";
                      } else {
                        spo_code[i] = "";
                        spo_code[i] += data1[i][j].spo_code + ",";
                      }
                    }
                    let reg = /,$/gi;
                    spo_code[i] = spo_code[i].replace(reg, "");
                    data1[i].ss = spo_code[i];
                  }

                  console.log(data1);



                  tnha.asnItem = asnItem;
                  tnha.specialService = data1;
                  tnha.specia = false;
                  tnha.Quantity = Quantity;
                  tnha.weight = weight * Quantity;
                  tnha.price = price * Quantity;
                  tnha.SPCode = SPCode;
                  tnha.AsnDetail = AsnDetail;
                  console.log(tnha)
                  this.companyList = tnha;
                  this.AsnCode = scope.row.AsnCode;
                  this.addVisible = true;
                  console.log(this.companyList);
                }
              } else {
                this.AsnCode = scope.row.AsnCode;
                let tnha = response.data.data;
                let Quantity = 0,
                  weight = 0,
                  price = 0;
                let SPCode = scope.row.SPCode;

                for (let i = 0; i < response.data.data.asnItem.length; i++) {
                  Quantity += Number(response.data.data.asnItem[i].quantity);
                  weight +=
                    Number(response.data.data.asnItem[i].weight) *
                    Number(response.data.data.asnItem[i].quantity);
                  price +=
                    Number(
                      response.data.data.asnItem[i].productDeclarationValue
                    ) * Number(response.data.data.asnItem[i].quantity);
                }
                let asnItem = response.data.data.asnItem;
                for (let i = 0; i < asnItem.length; i++) {
                  for (let j = 0; j < AsnDetail.length; j++) {
                    if (asnItem[i].sku == AsnDetail[j].sku) {
                      asnItem[i].quantity = Number(asnItem[i].quantity);
                      asnItem[i].problemQuantity = Number(
                        AsnDetail[j].nopassQty
                      );
                      asnItem[i].receivedQty = Number(AsnDetail[j].receivedQty);
                      asnItem[i].orderQty = Number(AsnDetail[j].orderQty);
                      asnItem[i].putawayQuantity = Number(AsnDetail[j].passQty);
                      asnItem[i].isEdit = Number(
                          AsnDetail[j].isEdit
                        );
                    }
                  }
                }
                tnha.asnItem = asnItem;
                tnha.Quantity = Quantity;
                tnha.weight = weight;
                tnha.price = price;
                tnha.SPCode = SPCode;
                tnha.AsnDetail = AsnDetail;
                console.log(tnha);
                this.companyList = tnha;
                this.addVisible = true;
              }

              console.log(response.data.data.asnItem.constructor);
            } else {
              if (response.data.data.specialService) {
                if (response.data.data.specialService.constructor === Array) {
                  let asnItem = [];
                  asnItem.push(response.data.data.asnItem);
                  let data1 = [];
                  let datan = {};
                  for (
                    let i = 0;
                    i < response.data.data.specialService.length;
                    i++
                  ) {
                    console.log(11);
                    for (let j = 0; j < asnItem.length; j++) {
                      console.log(11);
                      if (
                        asnItem[j].sku ==
                        response.data.data.specialService[i].sku
                      ) {
                        console.log(response.data.data.specialService[i]);
                        if (!datan[response.data.data.specialService[i].sku]) {
                          datan[response.data.data.specialService[i].sku] = [];
                          datan[response.data.data.specialService[i].sku][0] =
                            response.data.data.specialService[i];
                        } else {
                          datan[response.data.data.specialService[i].sku][
                            datan[
                              response.data.data.specialService[i].sku
                            ].length
                          ] = response.data.data.specialService[i];
                        }
                        data1.push(
                          datan[response.data.data.specialService[i].sku]
                        );
                      }
                    }
                  }
                  for (let i = 0; i < data1.length; i++) {
                    if (data1.indexOf(data1[i]) != i) {
                      data1.splice(i, 1);
                      i--;
                    }
                  }
                  let spo_code = [];
                  for (let i = 0; i < data1.length; i++) {
                    for (let j = 0; j < data1[i].length; j++) {
                      if (spo_code[i]) {
                        if (data1[i][j - 1].spo_code != data1[i][j].spo_code) {
                          spo_code[i] += data1[i][j].spo_code + ",";
                        }
                      } else {
                        spo_code[i] = "";
                        spo_code[i] += data1[i][j].spo_code + ",";
                      }
                    }
                    let reg = /,$/gi;
                    spo_code[i] = spo_code[i].replace(reg, "");
                    data1[i].ss = spo_code[i];
                  }

                  console.log(data1);
                  let Quantity = response.data.data.asnItem.quantity;
                  let weight = response.data.data.asnItem.weight;
                  let price =
                    response.data.data.asnItem.productDeclarationValue;
                  let SPCode = scope.row.SPCode;
                  let tnha = response.data.data;
                  console.log(tnha);
                  for (let i = 0; i < asnItem.length; i++) {
                    for (let j = 0; j < AsnDetail.length; j++) {
                      if (asnItem[i].sku == AsnDetail[j].sku) {
                        asnItem[i].quantity = Number(asnItem[i].quantity);
                        asnItem[i].problemQuantity = Number(
                          AsnDetail[j].nopassQty
                        );
                        asnItem[i].receivedQty = Number(
                          AsnDetail[j].receivedQty
                        );
                        asnItem[i].orderQty = Number(AsnDetail[j].orderQty);
                        asnItem[i].putawayQuantity = Number(
                          AsnDetail[j].passQty
                        );
                        asnItem[i].isEdit = Number(
                          AsnDetail[j].isEdit
                        );
                      }
                    }
                  }
                  tnha.asnItem = asnItem;
                  tnha.Quantity = Quantity;
                  tnha.weight = weight * Quantity;
                  tnha.price = price * Quantity;
                  tnha.SPCode = SPCode;
                  tnha.specialService = data1;
                  tnha.AsnDetail = AsnDetail;
                  this.companyList = tnha;
                  this.AsnCode = scope.row.AsnCode;
                  this.addVisible = true;
                  console.log(this.companyList);
                } else {
                  let Quantity = response.data.data.asnItem.quantity;
                  let weight = response.data.data.asnItem.weight;
                  let price =
                    response.data.data.asnItem.productDeclarationValue;
                  let SPCode = scope.row.SPCode;
                  let tnha = response.data.data;
                  console.log(tnha);
                  let asnItem = [];
                  let specialService = [];
                  asnItem.push(response.data.data.asnItem);
                  for (let i = 0; i < asnItem.length; i++) {
                    for (let j = 0; j < AsnDetail.length; j++) {
                      if (asnItem[i].sku == AsnDetail[j].sku) {
                        asnItem[i].quantity = Number(asnItem[i].quantity);
                        asnItem[i].problemQuantity = Number(
                          AsnDetail[j].nopassQty
                        );
                        asnItem[i].receivedQty = Number(
                          AsnDetail[j].receivedQty
                        );
                        asnItem[i].orderQty = Number(AsnDetail[j].orderQty);
                        asnItem[i].putawayQuantity = Number(
                          AsnDetail[j].passQty
                        );
                        asnItem[i].isEdit = Number(
                          AsnDetail[j].isEdit
                        );
                      }
                    }
                  }
                  specialService.push(response.data.data.specialService);
                  let data1 = [];
                  let datan = {};
                  for (let i = 0; i < specialService.length; i++) {
                    console.log(11);
                    for (let j = 0; j < asnItem.length; j++) {
                      console.log(11);
                      if (asnItem[j].sku == specialService[i].sku) {
                        console.log(specialService[i]);
                        if (!datan[specialService[i].sku]) {
                          datan[specialService[i].sku] = [];
                          datan[specialService[i].sku][0] = specialService[i];
                        } else {
                          datan[specialService[i].sku][
                            datan[specialService[i].sku].length
                          ] = specialService[i];
                        }
                        data1.push(datan[specialService[i].sku]);
                      }
                    }
                  }
                  for (let i = 0; i < data1.length; i++) {
                    if (data1.indexOf(data1[i]) != i) {
                      data1.splice(i, 1);
                      i--;
                    }
                  }
                  let spo_code = [];
                  for (let i = 0; i < data1.length; i++) {
                    for (let j = 0; j < data1[i].length; j++) {
                      if (spo_code[i]) {
                        if (data1[i][j - 1].spo_code != data1[i][j].spo_code) {
                          spo_code[i] += data1[i][j].spo_code + ",";
                        }
                      } else {
                        spo_code[i] = "";
                        spo_code[i] += data1[i][j].spo_code + ",";
                      }
                    }
                    let reg = /,$/gi;
                    spo_code[i] = spo_code[i].replace(reg, "");
                    data1[i].ss = spo_code[i];
                  }
                  console.log(data1);
                  tnha.asnItem = asnItem;
                  tnha.specialService = data1;
                  tnha.Quantity = Quantity;
                  tnha.weight = weight * Quantity;
                  tnha.price = price * Quantity;
                  tnha.SPCode = SPCode;
                  tnha.AsnDetail = AsnDetail;

                  this.companyList = tnha;
                  this.AsnCode = scope.row.AsnCode;
                  this.addVisible = true;
                  console.log(this.companyList);
                }
              } else {
                let Quantity = response.data.data.asnItem.quantity;
                let weight = response.data.data.asnItem.weight;
                let price = response.data.data.asnItem.productDeclarationValue;
                let SPCode = scope.row.SPCode;
                let tnha = response.data.data;
                console.log(tnha);
                let asnItem = [];
                asnItem.push(response.data.data.asnItem);
                for (let i = 0; i < asnItem.length; i++) {
                  for (let j = 0; j < AsnDetail.length; j++) {
                    if (asnItem[i].sku == AsnDetail[j].sku) {
                      asnItem[i].quantity = Number(asnItem[i].quantity);
                      asnItem[i].problemQuantity = Number(
                        AsnDetail[j].nopassQty
                      );
                      asnItem[i].receivedQty = Number(AsnDetail[j].receivedQty);
                      asnItem[i].orderQty = Number(AsnDetail[j].orderQty);
                      asnItem[i].putawayQuantity = Number(AsnDetail[j].passQty);
                      asnItem[i].isEdit = Number(
                          AsnDetail[j].isEdit
                        );
                    }
                  }
                }
                tnha.asnItem = asnItem;
                tnha.Quantity = Quantity;
                tnha.weight = weight * Quantity;
                tnha.price = price * Quantity;
                tnha.SPCode = SPCode;
                tnha.AsnDetail = AsnDetail;
                this.companyList = tnha;
                this.AsnCode = scope.row.AsnCode;
                this.addVisible = true;
                console.log(this.companyList);
              }
            }

            console.log(scope);
          }
        })
        .catch(error => {
          console.log(error);
        });
    },
    Reshipment(scope) {
      console.log(scope.row);

      this.asn_code = scope.row.AsnCode;
      this.waybillnumberVisible = true;
    },

    //取消
    handleDialogClose() {
      let form = "form";
      this.$refs[form].resetFields();
      this.waybillnumberVisible = false;
    },
    //确定
    subnumber() {
      console.log(this.form);
      let param = {
        asn_code: this.asn_code,
        supplier: this.form.region,
        tracking_number: this.form.Amount
      };
      updatetracking(param)
        .then(response => {
          console.log(response);
          if (response.data.ask == 1) {
            this.waybillnumberVisible = false;
            let param = { asn_status: 2 };
            getasnlist(param)
              .then(response => {
                console.log(response);
                let tableData;
                if (response.data.ask == 1) {
                  console.log(response.data.data.constructor === Array);
                  if (response.data.data.constructor === Array) {
                    tableData = response.data.data;
                    for (let i = 0; i < tableData.length; i++) {
                      if (tableData[i].AsnDetail) {
                        tableData[i].nopassQty = 0;
                        tableData[i].passQty = 0;
                        tableData[i].noDelivery = 0;
                        tableData[i].receivedQty = 0;
                        if (tableData[i].AsnDetail.constructor === Array) {
                          for (
                            let j = 0;
                            j < tableData[i].AsnDetail.length;
                            j++
                          ) {
                            tableData[i].nopassQty += Number(
                              tableData[i].AsnDetail[j].nopassQty
                            );

                            tableData[i].passQty += Number(
                              tableData[i].AsnDetail[j].passQty
                            );
                            tableData[i].noDelivery += Number(
                              tableData[i].AsnDetail[j].orderQty
                            );
                            tableData[i].receivedQty += Number(
                              tableData[i].AsnDetail[j].noDelivery1
                            );
                          }
                        } else {
                          tableData[i].nopassQty = Number(
                            tableData[i].AsnDetail.nopassQty
                          );
                          tableData[i].noDelivery = Number(
                            tableData[i].AsnDetail.orderQty
                          );
                          tableData[i].receivedQty = Number(
                            tableData[i].AsnDetail.noDelivery1
                          );
                          tableData[i].passQty = Number(
                            tableData[i].AsnDetail.passQty
                          );
                        }
                      }
                    }
                    this.tableData = tableData;
                  } else {
                    let tableData = [];
                    tableData.push(response.data.data);
                    for (let i = 0; i < tableData.length; i++) {
                      if (tableData[i].AsnDetail) {
                        if (tableData[i].AsnDetail.constructor === Array) {
                          tableData[i].nopassQty = 0;
                          tableData[i].passQty = 0;
                          tableData[i].noDelivery = 0;
                          tableData[i].receivedQty = 0;
                          for (
                            let j = 0;
                            j < tableData[i].AsnDetail.length;
                            j++
                          ) {
                            tableData[i].nopassQty += Number(
                              tableData[i].AsnDetail[j].nopassQty
                            );
                            tableData[i].passQty += Number(
                              tableData[i].AsnDetail[j].passQty
                            );
                            tableData[i].noDelivery += Number(
                              tableData[i].AsnDetail[j].orderQty
                            );
                            tableData[i].receivedQty += Number(
                              tableData[i].AsnDetail[j].noDelivery1
                            );
                          }
                        } else {
                          tableData[i].nopassQty = Number(
                            tableData[i].AsnDetail.nopassQty
                          );
                          tableData[i].noDelivery = Number(
                            tableData[i].AsnDetail.orderQty
                          );
                          tableData[i].receivedQty = Number(
                            tableData[i].AsnDetail.noDelivery1
                          );
                          tableData[i].passQty = Number(
                            tableData[i].AsnDetail.passQty
                          );
                        }
                      }
                    }
                    this.tableData = tableData;
                  }
                }
              })
              .catch(error => {
                console.log(error);
              });
          }
        })
        .catch(error => {
          console.log(error);
        });
    },
    clearAdd() {
      this.addVisible = false;
    }
  }
};
</script>
<style>
.Synchronize {
  float: right;
  font-size: 14px;
  color: #8989ba;
}
.ban {
  background: #fff;
  margin: 20px;
  padding: 20px;
}
.demo-input-suffix {
  padding-bottom: 20px;
  text-align: left;
}
.input {
  width: 200px;
}
.pagination {
  margin-top: 20px;
}
a {
  color: #8989ba;
  cursor: pointer;
}
</style>



// WEBPACK FOOTER //
// src/components/views/AsnOrder/AsnOrder.vue